import React from "react";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Modal } from "@mui/material";
import { useNavigate } from "hooks";

import "./DataRoomConnected.styles.scss";

interface DataRoomConnectedProps {
  connectionId: number | null;
  onClose: () => void;
}

export const DataRoomConnected: React.FC<DataRoomConnectedProps> = ({ connectionId, onClose }) => {
  const navigate = useNavigate();

  return (
    <Modal open={!!connectionId} onClose={onClose}>
      <Box sx={style}>
        <div className="data-room-connected">
          <div className="head">
            <span>Connect to Data Room</span>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="body">
            <span className="message">
              Connection to data room was made successfully. We download files for the last year. When all files have
              been downloaded, you will receive a message by email.
            </span>
            <CheckCircleOutlineIcon
              fontSize="xl"
              sx={{
                color: "#1c8a0a",
                fontSize: "81px",
                marginBottom: "41px"
              }}
            />
            <Button
              variant="contained"
              onClick={() => {
                if (connectionId) {
                  onClose();
                  navigate({ route: "dataRoom", params: { room_id: connectionId } });
                }
              }}
            >
              Go to Data Room
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none"
};
